(() => {
  const root = document.querySelector('[data-pk-opening-gift]');
  if (!root) return;
  const manualPackIn = root.dataset.packinGifts === 'manual';
  const cartRoot = root.dataset.cartRoot || '/';
  const giftProperty = '_pk_opening_gift';
  const source = 'pk-first-order-gift';
  const giftIds = new Set([root.dataset.giftCardProductId, root.dataset.giftAmuletProductId, root.dataset.giftAromaProductId].map(Number));
  const managed = item => giftIds.has(Number(item.product_id)) && item.properties?.[giftProperty] === 'true';
  let inFlight = null;
  let queued = false;
  let checkoutReady = false;
  let guardNeeded = !manualPackIn && (root.dataset.hasManagedGifts === 'true' || root.dataset.giftEligible === 'true');
  const request = async (path, body) => {
    const response = await fetch(cartRoot + path, body ? {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)} : {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error('Gift cart sync failed');
    return response.json();
  };
  const notice = key => {
    document.querySelectorAll('[data-pk-gift-status]').forEach(el => { el.textContent = root.dataset[key] || ''; });
  };
  const syncOnce = async () => {
    let changed = false;
    const response = await fetch(cartRoot + '?section_id=pk-first-order-gift-state', {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error('Gift eligibility check failed');
    const match = (await response.text()).match(/<script[^>]*data-pk-gift-state[^>]*>([\s\S]*?)<\/script>/);
    if (!match) throw new Error('Gift eligibility unavailable');
    const state = JSON.parse(match[1]);
    let cart = await request('cart.js');
    guardNeeded = cart.items.some(managed) || state.eligible === true;
    const qualifies = state.eligible === true && state.qualifying === true && cart.items.some(item => !giftIds.has(Number(item.product_id)) && item.requires_shipping && Number(item.final_line_price) > 0);
    const hasAmulet = cart.items.some(item => managed(item) && Number(item.product_id) === state.amuletProductId);
    const hasCard = cart.items.some(item => managed(item) && Number(item.product_id) === state.cardProductId);
    const available = (state.amuletVariantIds.length > 0 || hasAmulet) && (state.cardVariantId > 0 || hasCard);
    const desired = qualifies && available ? 1 : 0;
    const retained = new Set();
    const updates = {};
    for (const item of cart.items.filter(managed)) {
      const id = Number(item.product_id);
      const keep = desired && [state.cardProductId, state.amuletProductId].includes(id) && !retained.has(id);
      if (keep) retained.add(id);
      if (item.quantity !== (keep ? 1 : 0)) updates[item.key] = keep ? 1 : 0;
    }
    if (Object.keys(updates).length) { await request('cart/update.js', {updates}); changed = true; }
    const additions = [];
    if (desired && !retained.has(state.cardProductId)) additions.push({id: state.cardVariantId, quantity: 1, properties: {[giftProperty]: 'true'}});
    if (desired && !retained.has(state.amuletProductId)) additions.push({id: state.amuletVariantIds[Math.floor(Math.random() * state.amuletVariantIds.length)], quantity: 1, properties: {[giftProperty]: 'true'}});
    if (additions.length) { await request('cart/add.js', {items: additions}); changed = true; }
    cart = await request('cart.js');
    // Never leave a managed gift in the bag at a non-zero price.
    const charged = cart.items.filter(item => managed(item) && Number(item.final_line_price) !== 0);
    if (charged.length) {
      await request('cart/update.js', {updates: Object.fromEntries(cart.items.filter(managed).map(item => [item.key, 0]))});
      cart = await request('cart.js');
      changed = true;
      notice('errorMessage');
    } else notice(!state.eligible ? 'loginMessage' : !available ? 'stockMessage' : desired ? 'readyMessage' : 'emptyMessage');
    if (changed && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') await publish(PUB_SUB_EVENTS.cartUpdate, {source, cartData: cart});
    return true;
  };
  const syncGift = () => {
    if (manualPackIn) {
      if (root.dataset.hasManagedGifts === 'true') document.querySelectorAll('[name="checkout"], a[href="/checkout"]').forEach(button => {
        const noticeAnchor = button.closest('.cart__ctas') || button;
        if (noticeAnchor.previousElementSibling?.hasAttribute('data-pk-legacy-gift-notice')) return;
        const message = document.createElement('p');
        message.setAttribute('data-pk-legacy-gift-notice', '');
        message.setAttribute('role', 'status');
        message.style.cssText = 'flex:0 0 auto;width:100%;box-sizing:border-box;padding:12px;margin:8px 0;border:1px solid #c7a45b;color:inherit;font-size:14px;line-height:1.5;white-space:normal';
        message.textContent = 'Gift entries from an earlier visit may still appear. Review these lines and your final total before paying. Current qualifying gifts are packed with your parcel and do not need separate checkout lines. Questions? zaufun@gmail.com.';
        noticeAnchor.insertAdjacentElement('beforebegin', message);
      });
      return Promise.resolve(true);
    }
    if (inFlight) { queued = true; return inFlight; }
    inFlight = (async () => {
      try {
        do { queued = false; await syncOnce(); } while (queued);
        return true;
      } catch (error) { notice('errorMessage'); console.warn(error); return false; }
      finally { inFlight = null; }
    })();
    return inFlight;
  };
  const readNoticeState = key => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
  const saveNoticeState = (key, value) => { try { sessionStorage.setItem(key, value ? '1' : '0'); } catch { /* Controls still work when storage is unavailable. */ } };
  const homeFloating = root.hasAttribute('data-pk-home-floating');
  const mobileNotice = window.matchMedia('(max-width: 749px)');
  let mobileMinimized = true;
  saveNoticeState('pk-opening-gift-dismissed', false);
  let minimized = true;
  const minimizeButton = root.querySelector('[data-pk-opening-gift-minimize]');
  const expandButton = root.querySelector('[data-pk-opening-gift-expand]');
  const benefits = root.querySelector('.pk-opening-gift-float__link');
  const positionKey = homeFloating ? 'pk-home-gift-position-v2' : 'pk-opening-gift-position';
  let position = null;
  let gesture = null;
  let mobileLauncherPosition = null;
  let suppressClickUntil = 0;
  try {
    const saved = JSON.parse(sessionStorage.getItem(positionKey));
    if (saved && Number.isFinite(saved.x) && Number.isFinite(saved.y)) position = saved;
  } catch { /* Dragging also works without session storage. */ }
  const placeNotice = (x, y, avoidMusic = true) => {
    const rect = root.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const viewport = window.visualViewport;
    const left = (viewport?.offsetLeft || 0) + 8;
    const top = (viewport?.offsetTop || 0) + 8;
    const right = Math.max(left, left + (viewport?.width || document.documentElement.clientWidth) - rect.width - 16);
    const bottom = Math.max(top, top + (viewport?.height || window.innerHeight) - rect.height - 16);
    if (root.classList.contains('pk-karma-float-v2') && homeFloating && mobileNotice.matches && !root.classList.contains('is-minimized')) {
      x = left + 4;
      y = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight) - rect.height - 190;
    }
    x = Math.min(right, Math.max(left, x));
    y = Math.min(bottom, Math.max(top, y));
    const music = document.querySelector('.pk-bgm');
    if (avoidMusic && music?.getClientRects().length && getComputedStyle(music).visibility !== 'hidden') {
      const m = music.getBoundingClientRect();
      const overlaps = (a, b) => a < m.right + 8 && a + rect.width > m.left - 8 && b < m.bottom + 8 && b + rect.height > m.top - 8;
      if (overlaps(x, y)) {
        const choices = [[x, m.top - rect.height - 8], [m.right + 8, y], [x, m.bottom + 8], [m.left - rect.width - 8, y]]
          .filter(([a, b]) => a >= left && a <= right && b >= top && b <= bottom && !overlaps(a, b))
          .sort((a, b) => Math.hypot(a[0] - x, a[1] - y) - Math.hypot(b[0] - x, b[1] - y));
        if (choices.length) [x, y] = choices[0];
      }
    }
    position = {x, y};
    root.style.setProperty('left', `${x}px`, homeFloating ? 'important' : '');
    root.style.setProperty('top', `${y}px`, homeFloating ? 'important' : '');
    root.style.bottom = 'auto';
    root.style.right = 'auto';
    root.classList.add('is-positioned');
  };
  const savePosition = () => { try { if (position) sessionStorage.setItem(positionKey, JSON.stringify(position)); } catch { /* Position stays usable for this page. */ } };
  const fitNotice = () => { if ((!mobileNotice.matches || homeFloating) && position) placeNotice(position.x, position.y); };
  root.addEventListener('pointerdown', event => {
    if ((mobileNotice.matches && !homeFloating) || event.isPrimary === false || event.button !== 0 || gesture) return;
    if (root.classList.contains('pk-karma-float-v2') && ((!event.target.closest('[data-pk-float-drag], [data-pk-opening-gift-expand]')) || (mobileNotice.matches && !root.classList.contains('is-minimized')))) return;
    suppressClickUntil = 0;
    if (event.target.closest('[data-pk-opening-gift-close], [data-pk-opening-gift-minimize]')) return;
    const rect = root.getBoundingClientRect();
    gesture = {id: event.pointerId, x: event.clientX, y: event.clientY, left: rect.left, top: rect.top, moved: false};
  });
  root.addEventListener('pointermove', event => {
    if (!gesture || event.pointerId !== gesture.id) return;
    const dx = event.clientX - gesture.x;
    const dy = event.clientY - gesture.y;
    if (!gesture.moved && Math.hypot(dx, dy) < 6) return;
    if (!gesture.moved) {
      gesture.moved = true;
      root.setPointerCapture(event.pointerId);
      root.classList.add('is-dragging');
    }
    event.preventDefault();
    placeNotice(gesture.left + dx, gesture.top + dy, false);
  });
  const finishDrag = event => {
    if (!gesture || event.pointerId !== gesture.id) return;
    const moved = gesture.moved;
    gesture = null;
    root.classList.remove('is-dragging');
    if (root.hasPointerCapture(event.pointerId)) root.releasePointerCapture(event.pointerId);
    if (moved) {
      suppressClickUntil = Date.now() + 700;
      fitNotice();
      savePosition();
    }
  };
  root.addEventListener('pointerup', finishDrag);
  root.addEventListener('pointercancel', finishDrag);
  root.addEventListener('lostpointercapture', finishDrag);
  root.addEventListener('pointerleave', event => { if (gesture && !gesture.moved) finishDrag(event); });
  root.addEventListener('dragstart', event => event.preventDefault());
  root.addEventListener('click', event => {
    if (event.detail !== 0 && Date.now() < suppressClickUntil) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('resize', fitNotice);
  window.visualViewport?.addEventListener('resize', fitNotice);
  window.visualViewport?.addEventListener('scroll', fitNotice);
  if (typeof ResizeObserver !== 'undefined') new ResizeObserver(fitNotice).observe(root);
  const updateVisibility = () => {
    const compact = mobileNotice.matches ? mobileMinimized : minimized;
    root.hidden = false;
    root.classList.toggle('is-minimized', compact);
    if (benefits) benefits.hidden = compact;
    if (minimizeButton) {
      minimizeButton.hidden = compact;
      minimizeButton.setAttribute('aria-expanded', String(!compact));
    }
    if (expandButton) {
      expandButton.hidden = !compact;
      expandButton.setAttribute('aria-expanded', String(!compact));
    }
    fitNotice();
  };
  minimizeButton?.addEventListener('click', () => {
    if (root.classList.contains('pk-karma-float-v2') && mobileNotice.matches && homeFloating) {
      position = mobileLauncherPosition;
      if (!position) {
        root.classList.remove('is-positioned');
        ['left', 'top', 'bottom', 'right'].forEach(property => root.style.removeProperty(property));
      }
    }
    if (mobileNotice.matches) mobileMinimized = true;
    else {
      minimized = true;
      saveNoticeState('pk-opening-gift-minimized', true);
    }
    updateVisibility();
    expandButton?.focus({preventScroll: true});
  });
  expandButton?.addEventListener('click', () => {
    if (root.classList.contains('pk-karma-float-v2') && mobileNotice.matches && homeFloating) mobileLauncherPosition = position ? {...position} : null;
    if (mobileNotice.matches) mobileMinimized = false;
    else {
      minimized = false;
      saveNoticeState('pk-opening-gift-minimized', false);
    }
    updateVisibility();
    minimizeButton?.focus({preventScroll: true});
  });
  root.querySelector('[data-pk-opening-gift-close]')?.addEventListener('click', () => {
    minimizeButton?.click();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !root.hidden && !root.classList.contains('is-minimized')) minimizeButton?.click();
  });
  const syncNoticeLayout = () => {
    root.classList.remove('is-mobile-flow');
    root.style.setProperty('position', 'fixed', 'important');
    root.style.setProperty('z-index', '2147483647', 'important');
    root.style.setProperty('visibility', 'visible', 'important');
    root.style.setProperty('display', 'block', 'important');
    root.style.setProperty('opacity', '1', 'important');
    if (root.parentNode !== document.body) document.body.appendChild(root);
    updateVisibility();
  };
  mobileNotice.addEventListener('change', syncNoticeLayout);
  document.addEventListener('pk:opening-gift-sync', syncGift);
  document.addEventListener('pk:oracle-result', () => {
    mobileMinimized = true;
    minimized = true;
    updateVisibility();
  });
  document.addEventListener('click', event => {
    if (!event.target.closest?.('[data-pk-benefits-open]')) return;
    event.preventDefault();
    expandButton?.click();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, event => { if (event.source !== source) return syncGift(); });
  // Ordinary cart checkout waits for the final gift check. Express checkout remains platform-managed.
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[name="checkout"], a[href="/checkout"]');
    if (!button || checkoutReady || (!guardNeeded && !inFlight)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (await syncGift()) { checkoutReady = true; button.click(); checkoutReady = false; }
  }, true);
  window.addEventListener('pageshow', syncGift);
  syncNoticeLayout();
  window.setTimeout(syncGift, 500);
})();


